import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';

export const authConfig: AuthConfig = {
    issuer: environment.idp.issuer,
    tokenEndpoint: `${environment.idp.issuer}/oauth2/token`,
    redirectUri: `${window.location.origin}`,
    clientId: environment.idp.clientId,
    responseType: 'code',
    scope: 'openid',
    strictDiscoveryDocumentValidation: false,
    showDebugInformation: true,
    disablePKCE: true,
    skipIssuerCheck: true,
};
